import { Brand } from '@snapchat/mw-common';
import type { MotifScheme } from '@snapchat/snap-design-system-marketing';
import { MotifScheme as MotifSchemeEnum } from '@snapchat/snap-design-system-marketing';

import { useBrand } from './useBrand';

/**
 * Resolves the `motifScheme` prop value based on the current site's brand.
 *
 * For sites with the `snap` brand, provides a `MotifScheme.DEFAULT` fallback to prevent SDS-M
 * components from applying their own internal fallback behavior.
 */
export function useMotifScheme(
  brandValue: MotifScheme | null | undefined
): MotifScheme | undefined {
  const brand = useBrand();

  if (brand === Brand.SNAP) {
    return brandValue ?? MotifSchemeEnum.DEFAULT;
  }

  return brandValue ?? undefined;
}
